import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { Global } from "@emotion/react";

import App from "./App";
import { theme } from "./styles/theme";
import { Web3ProviderProvider } from "./contexts/Web3Provider";
import { VerificationContextProvider } from "./contexts/Verification";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Global
      styles={`
        @font-face {
          font-family: "ModernEra-Regular";
          font-style: normal;
          font-weight: normal;
          src: url("/fonts/ModernEra-Regular.woff2") format("woff2"), url("/fonts/ModernEra-Regular.woff") format("woff");
        }
      `}
    />
    <ChakraProvider theme={extendTheme(theme)}>
      <Web3ProviderProvider>
        <VerificationContextProvider>
          <App />
        </VerificationContextProvider>
      </Web3ProviderProvider>
    </ChakraProvider>
  </React.StrictMode>
);
